// 奈瑞儿
// 体质报告等等
const natvip = r =>
    require.ensure(
        [],
        () => r(require("../views/natvip/index.vue")),
        "natvip"
    );
const meridianwhole = r =>
    require.ensure(
        [],
        () => r(require("../views/natvip/meridianwhole.vue")),
        "meridianwhole"
    );
// 皮测报告-首页
const skinReport = r =>
    require.ensure(
        [],
        () => r(require("../views/natvip/skinReport.vue")),
        "skinReport"
    );
// 皮测报告-二级页面检测分析
const skinDetail = r =>
    require.ensure(
        [],
        () => r(require("../views/natvip/skinDetail.vue")),
        "skinDetail"
    );

// 皮测报告-肤质、肤色、肤龄图片检测分析
const skinImgDetail = r =>
    require.ensure(
        [],
        () => r(require("../views/natvip/skinImgDetail.vue")),
        "skinImgDetail"
    );
// 皮测报告-雷达图检测分析
const skinRadar = r =>
    require.ensure(
        [],
        () => r(require("../views/natvip/skinRadar.vue")),
        "skinRadar"
    );
// 问卷好评
const questionnaireEvalution = r =>
    require.ensure(
        [],
        () => r(require("../views/questionnaireEvalution/index.vue")),
        "questionnaireEvalution"
    );
const meridianwholeNew = r =>
  require.ensure(
    [],
    () => r(require("../views/natvip/meridianwholeNew.vue")),
    "meridianwholeNew"
  );
const meridianVein = r =>
  require.ensure(
    [],
    () => r(require("../views/natvip/meridianVein.vue")),
    "meridianVein"
  );
const meridinProject = r =>
  require.ensure(
    [],
    () => r(require("../views/natvip/meridianProject.vue")),
    "meridinProject"
  );
const meridianCompare = r =>
  require.ensure(
    [],
    () => r(require("../views/natvip/meridianCompare.vue")),
    "meridianCompare"
  );

// 评价
const evaluateSuccess = r =>
    require.ensure(
        [],
        () => r(require("../views/evaluateSuccess/index.vue")),
        "evaluateSuccess"
    );
const routes = [
    {
        path: "/natvip",
        name: "natvip",
        component: natvip,
        meta: {
            title: "报告详情"
        }
    },
    {
        path: "/meridianwhole",
        name: "meridianwhole",
        component: meridianwhole,
        meta: {
            title: "经络完整数据"
        }
    },
    {
        path: "/skinReport",
        name: "skinReport",
        component: skinReport,
        meta: {
            title: "全肤智测报告"
        }
    },
    {
        path: "/skinDetail",
        name: "skinDetail",
        component: skinDetail,
        meta: {
            title: "详细分析"
        }
    },
    {
        path: "/skinImgDetail",
        name: "skinImgDetail",
        component: skinImgDetail,
        meta: {
            title: "图片检测分析"
        }
    },
    {
        path: "/skinRadar",
        name: "skinRadar",
        component: skinRadar,
        meta: {
            title: "雷达图检测分析",
            keepAlive: true
        }
    },
    {
        path: "/questionnaireEvalution",
        name: "questionnaireEvalution",
        component: questionnaireEvalution,
        meta: {
            title: "评价成功",
        }
    },
    {
        path: "/evaluateSuccess",
        name: "evaluateSuccess",
        component: evaluateSuccess,
        meta: {
            title: "评价",
        }
    },
    {
      path: "/meridianwholeNew",
      name: "meridianwholeNew",
      component: meridianwholeNew,
      meta: {
        title: "经络报告",
      }
    },
    {
      path: "/veinReport",
      name: "meridianVein",
      component: meridianVein,
      meta: {
        title: "经络报告",
        keepAlive: true
      }
    },
    {
      path: "/meridianProject",
      name: "meridianProject",
      component: meridinProject,
      meta: {
        title: "经络历年项目"
      }
    },
    {
      path: "/meridianCompare",
      name: "meridianCompare",
      component: meridianCompare,
      meta: {
        title: "经络对比报告",
      }
    },
]

export default routes;


// WEBPACK FOOTER //
// ./src/router/natvip.js